import { observer } from "mobx-react";

import BlockTypeFilter from "./BlockTypeFilter";
import { useStores } from "../../../stores/useStores";
import styles from "./styles/BlockTypeFilters.module.scss";

interface IBlockTypeFiltersProps {
  isSearchingGoogleDrive?: boolean;
  isSearchingOffice365Drive?: boolean;
}

const BlockTypeFilters = observer((props: IBlockTypeFiltersProps) => {
  const { gridStore } = useStores();
  const { isSearchingGoogleDrive, isSearchingOffice365Drive } = props;

  const blockTypes = gridStore.blockTypeFilters.filters;

  let fileSearchWarning;

  if (isSearchingGoogleDrive || isSearchingOffice365Drive) {
    let vendor;
    if (isSearchingGoogleDrive) {
      vendor = " Google Drive";
    } else if (isSearchingOffice365Drive) {
      vendor = " Office365 One Drive";
    }

    fileSearchWarning = (
      <div className="sb-navbar-search-label">
        To make your searching most effective, we&#39;ve included results from
        your
        {vendor} account. No one else can see these same results.
      </div>
    );
  }

  return (
    <div className="sb-content-width">
      <div className="sb-headerSchool-block">
        <ul className={styles.filterList}>
          <li key={0}>
            <span style={{ marginLeft: 10 }}>Filter results by:</span>
          </li>
          <li key={1} className={styles.xsOnlyBreak}>
            <span />
          </li>
          {Array.from<any>(blockTypes.values()).map((blockType) => {
            return <BlockTypeFilter key={blockType.id} blockType={blockType} />;
          })}
        </ul>
        {fileSearchWarning}
      </div>
    </div>
  );
});

export default BlockTypeFilters;
